import { ConstraintCheckResult } from './constraint-check-result';

export class ConstraintCheckResults {

  private _checkResults: ConstraintCheckResult[];
  public errorTooltipText: string = ''; // tooltip text to show for check results
  public containsErrors: boolean = false; // if check results contains errors
  public containsStrictConformityErrors: boolean = false;
  public textCompression: number = NaN;
  public fontSize: number = NaN;

  constructor() {
    this._checkResults = [];
  }

  public addAll(checkResults: ConstraintCheckResults): void {
    for (const checkResult of checkResults.getAll()) {
      this._checkResults.push(checkResult);
    }
  }

  public getAll(): ConstraintCheckResult[] {
    return this._checkResults;
  }

  public addItem(checkResult: ConstraintCheckResult): void {
    this._checkResults.push(checkResult);
  }

  public get length(): number {
    return this._checkResults.length;
  }

}
